import React, { useState } from 'react';
import { C } from '../style/screen.style';
import { P } from '../style/phone.style';
import { ParentsLoading } from '../../../assets/image/screen';
import Bridge from './Bridge';

const ParentsAmule: React.FC = () => {
  const [active, setActive] = useState(false);
  return (
    <C.Wrapper>
      {!active && (
        <>
          <C.Loading src={ParentsLoading} />
          <C.BtnWrapper>
            <C.Button onClick={() => setActive(true)}>
              <P.ItemText>둘러보기</P.ItemText>
            </C.Button>
            <C.BtnBack />
          </C.BtnWrapper>
        </>
      )}
      {active && <Bridge />}
    </C.Wrapper>
  );
};

export default ParentsAmule;
